import '@js-joda/timezone';

import {
  ChronoUnit,
  DateTimeFormatter,
  ZonedDateTime,
  ZoneId,
} from '@js-joda/core';

type TimeDistanceOptions = {
  short?: boolean;
  suffix?: 'ago' | 'left' | '';
};

// TODO: Adjust once we take care of translations
export function formatTimeDistance(
  isoString: string,
  options: TimeDistanceOptions = {},
): string {
  const { short = false, suffix = 'ago' } = options;

  let parsedDate: ZonedDateTime;

  try {
    parsedDate = ZonedDateTime.parse(
      isoString,
      DateTimeFormatter.ISO_ZONED_DATE_TIME,
    );
  } catch {
    parsedDate = ZonedDateTime.parse(
      isoString,
      DateTimeFormatter.ISO_OFFSET_DATE_TIME,
    );
  }

  const now = ZonedDateTime.now(ZoneId.UTC);

  const units: { unit: ChronoUnit; short: string; long: string }[] = [
    { unit: ChronoUnit.YEARS, short: 'y', long: 'year' },
    { unit: ChronoUnit.MONTHS, short: 'mo', long: 'month' },
    { unit: ChronoUnit.WEEKS, short: 'w', long: 'week' },
    { unit: ChronoUnit.DAYS, short: 'd', long: 'day' },
    { unit: ChronoUnit.HOURS, short: 'h', long: 'hour' },
    { unit: ChronoUnit.MINUTES, short: 'm', long: 'minute' },
  ];

  for (const { unit, short: shortLabel, long: longLabel } of units) {
    const diff = parsedDate.until(now, unit);

    if (diff > 0) {
      const label = short
        ? `${diff}${shortLabel}`
        : `${diff} ${longLabel}${diff > 1 ? 's' : ''}`;

      if (!suffix) return label;

      return `${label} ${suffix}`;
    }
  }

  return short ? 'now' : 'Just now';
}
